// Description: Endpoint to delete one list
// Updated: 08/09/2025
// Author: Simon Franklin

import { getTokenData } from "../../../shared/utils/utils";

export async function DeleteListagens(id) {
    try {

        const { token, client_id } = await getTokenData();

        if (!token) throw new Error('Token de autenticação não encontrado');

        if (!client_id) throw new Error('ID do cliente não encontrado');

        const response = await fetch(`${process.env.REACT_APP_BACKEND_AWS_URL}/sheets?id=${id}`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `${token}`,
                'Client_ID': `${client_id}`
            }
        });
        
        const responseData = await response.json();

        return responseData;
    } catch (error) {
        console.error('Erro ao buscar dados da API:', error);
        throw new Error('Erro ao buscar dados da API');
    }
}